import React, { useState } from "react";
import axios from 'axios';

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/customer/login/', { username, password });
      console.log('Response:', response.data);
      // Handle successful login, redirect user, etc.
    } catch (error) {
      console.error('Error:', error.response.data);
      // Handle error, display error message, etc.
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4 text-center text-navy-blue">Inloggen</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Gebruikersnaam"
          className="block w-full mb-2 p-2 border rounded"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Wachtwoord"
          className="block w-full mb-2 p-2 border rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <label className="flex items-center mb-2">
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            className="mr-4"
          />
          <span className="text-gray-600">Onthoud mij</span>
        </label>
        <button type="submit" className="block w-full bg-blue-500 text-white p-2 rounded">
          Inloggen
        </button>
      </form>
    </div>
  );
};

export default Login;
